import React from 'react';
import { Grid, TextField } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    input: {
        textAlign: 'center',
        fontSize: theme.typography.body2.fontSize,
        padding: theme.spacing(1) / 2
    }
});

class DurationTextField extends React.Component {
    state = {
        minutes: undefined,
        seconds: undefined
    }

    render() {
        const { classes, value, ariaLabel } = this.props;
        const valueParts = this.getValueStrings(value);

        const getInputProps = (unit) => ({
            className: classes.input,
            'aria-label': `${ariaLabel} ${unit}`
        });

        return (
            <Grid container
                wrap='nowrap'
                gap={0.5}
                alignItems='center'
            >
                <Grid>
                    <TextField
                        variant="standard"
                        value={(this.state.minutes != undefined ? this.state.minutes : valueParts.minutes)}
                        inputProps={getInputProps('minutes')}
                        onChange={this.onMinutesChange}
                        onBlur={this.onMinutesBlur}
                    />
                </Grid>
                <Grid sx={{ display: "flex" }} justifyContent="center">
                    <b style={{ marginTop: 6 }}>:</b>
                </Grid>
                <Grid>
                    <TextField
                        variant="standard"
                        value={(this.state.seconds != undefined ? this.state.seconds : valueParts.seconds)}
                        inputProps={getInputProps('seconds')}
                        onChange={this.onSecondsChange}
                        onBlur={this.onSecondsBlur}
                    />
                </Grid>
            </Grid>
        );
    }

    onMinutesChange = (e) => {
        if (this.isNumericOrEmpty(e.target.value)) {
            this.setState({minutes: e.target.value})
        }
    }

    onSecondsChange = (e) => {
        if (this.isNumericOrEmpty(e.target.value)) {
            this.setState({seconds: e.target.value})
        }
    }

    onMinutesBlur = (e) => {
        if (this.state.minutes != undefined) {
            let value = parseInt(this.state.minutes);

            if (isNaN(value)) {
                value = 0;
            }
    
            this.setState({ minutes: undefined });
            this.props.onChange(value * 60 + this.getValueParts(this.props.value).seconds);
        }
    }

    onSecondsBlur = (e) => {
        if (this.state.seconds !== undefined) {
            let value = this.state.seconds.slice(-2);
            value = parseInt(value);

            if (value > 60) {
                value = this.state.seconds.slice(-1);
                value = parseInt(value);
            }
            if (isNaN(value)) {
                value = 0;
            }

            this.setState({ seconds: undefined });
            this.props.onChange(this.getValueParts(this.props.value).minutes * 60 + value);
        }
    }
    
    getValueParts = (value) => {
        return {
            minutes: Math.floor(value / 60),
            seconds: Math.round(value % 60)
        };
    }

    getValueStrings = (value) => {
        const valueParts = this.getValueParts(value);

        return {
            minutes: valueParts.minutes.toString(),
            seconds: valueParts.seconds.toString().length === 1 ? '0' + valueParts.seconds.toString() : valueParts.seconds.toString()
        };
    }

    isNumericOrEmpty = (value) => {
        return /^\d+$/.test(value) || value === '';
    }
}

export default withStyles(DurationTextField, styles);